module.exports = __webpack_public_path__ + "static/img/20015 (3).93ab85a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (3).webp
// module id = ayYx
// module chunks = 14